import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { InspirationMessage } from "./inspiration/InspirationMessage";
import { WeeklyRecapCard } from "./inspiration/WeeklyRecapCard";

// Carte Mon matin : message Inspiration Kaizen du jour (canal V1 : in-app, courriel OFF).
export function InspirationCard() {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/inspiration/today").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  return (
    <div className="rounded-2xl border border-[#C9A961]/30 bg-[#C9A961]/5 p-4" data-testid="mm-inspiration-card">
      <div className="flex items-center gap-2 mb-2"><span className="text-lg">✨</span><h3 className="font-semibold text-sm">Inspiration Kaizen</h3>
        <span className="text-[11px] text-zinc-500">{d.config.enabled ? `${d.config.send_hour_local} h 00 · ${d.paused ? "en pause" : "actif"}` : "non activé"}</span>
        <Link to="/app/standard-qualite?tab=inspiration" className="ml-auto text-xs text-[#C9A961] hover:underline" data-testid="mm-inspiration-link">Bibliothèque & réglages →</Link></div>
      {d.message ? <InspirationMessage m={d.message} onChange={load} compact /> : (
        <p className="text-xs text-zinc-400" data-testid="mm-inspiration-empty">{d.config.enabled ? `Le message du jour arrivera à ${d.config.send_hour_local} h 00.` : "Active l'inspiration quotidienne dans Standard Qualité › ✨ Inspiration (activation manuelle)."}</p>
      )}
      {d.is_sunday && <div className="mt-3"><WeeklyRecapCard compact /></div>}
    </div>
  );
}
